import app from '../../forum/app';
import Component from '../../common/Component';
import Button from '../../common/components/Button';
import LogInModal from './LogInModal';
import SignUpModal from './SignUpModal';
import SessionDropdown from './SessionDropdown';
import SelectDropdown from '../../common/components/SelectDropdown';
import NotificationsDropdown from './NotificationsDropdown';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';
import Search from '../components/Search';
import DiscussionComposer from './DiscussionComposer';

/**
 * The `HeaderSecondary` component displays secondary header controls, such as
 * the search box and the user menu. On the default skin, these are shown on the
 * right side of the header.
 * 导航右边部分【搜索、发布、注册、登录】
 */
export default class HeaderSecondary extends Component {
  view() {
    return <ul className="Header-controls">{listItems(this.items().toArray())}</ul>;
  }

  /**
   * Build an item list for the controls.
   *
   * @return {ItemList}
   */
  items() {
    const items = new ItemList();
    const canStartDiscussion = app.forum.attribute('canStartDiscussion') || !app.session.user;

    items.add(
      'newDiscussion',
      <Button
        icon="fas fa-edit"
        className="Button Button--primary IndexPage-newDiscussion"
        itemClassName="App-primaryControl"
        onclick={() => {
          // If the user is not logged in, the promise rejects, and a login modal shows up.
          // Since that's already handled, we dont need to show an error message in the console.
          return this.newDiscussionAction().catch(() => {});
        }}
        disabled={!canStartDiscussion}
      >
        {app.translator.trans(`core.forum.index.${canStartDiscussion ? 'start_discussion_button' : 'cannot_start_discussion_button'}`)}
      </Button>,
      40
    );

    items.add('search', <Search state={app.search} />, 30);

    const isAdmin = app.forum.attribute('adminUrl');

    if (isAdmin && app.forum.attribute('showLanguageSelector') && Object.keys(app.data.locales).length > 1) {
      const locales = [];

      for (const locale in app.data.locales) {
        locales.push(
          <Button
            active={app.data.locale === locale}
            icon={app.data.locale === locale ? 'fas fa-check' : true}
            onclick={() => {
              if (app.session.user) {
                app.session.user.savePreferences({ locale }).then(() => window.location.reload());
              } else {
                document.cookie = `locale=${locale}; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT`;
                window.location.reload();
              }
            }}
          >
            {app.data.locales[locale]}
          </Button>
        );
      }

      items.add(
        'locale',
        <SelectDropdown
          buttonClassName="Button Button--link"
          accessibleToggleLabel={app.translator.trans('core.forum.header.locale_dropdown_accessible_label')}
        >
          {locales}
        </SelectDropdown>,
        -10
      );
    }

    if (app.session.user) {
      // items.add('notifications', <NotificationsDropdown state={app.notifications} />, 10);
      items.add('session', <SessionDropdown />, -20);
    } else {
      if (app.forum.attribute('allowSignUp')) {
        items.add(
          'signUp',
          <Button className="Button Button--link" onclick={() => app.modal.show(SignUpModal)}>
            {app.translator.trans('core.forum.header.sign_up_link')}
          </Button>,
          -20
        );
      }

      items.add(
        'logIn',
        <Button className="Button Button--link" onclick={() => app.modal.show(LogInModal)}>
          {app.translator.trans('core.forum.header.log_in_link')}
        </Button>,
        -30
      );
    }

    return items;
  }


  /**
   * Open the composer for a new discussion or prompt the user to login.
   * 点击论坛按钮
   */
  newDiscussionAction() {
    return new Promise((resolve, reject) => {
      if (app.session.user) {
        m.route.set(app.route('forum'));

        if (!app.composer.bodyMatches(DiscussionComposer)) {
          app.composer.load(DiscussionComposer, {user: app.session.user});
        }

        if (!app.composer.isVisible()) {
          app.composer.show();
        }

        return resolve(app.composer);
      } else {
        app.modal.show(LogInModal);

        return reject();
      }
    });
  }
}
